import styled from 'styled-components'

import media from '../utils/style-utils'

export default styled.div`
  width: 95%;
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  ${media.greaterThan('small')`
    width: 80%;`
  }
`



// WEBPACK FOOTER //
// ./src/components/Container.js